var map = {
	"./img02.jpeg": "cefa",
	"./img03.jpeg": "b22d",
	"./img05.jpeg": "dbc6",
	"./img06.jpeg": "15d9",
	"./img07.jpeg": "b83b",
	"./img08.jpeg": "5ecd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8b1a";